import { render, staticRenderFns } from "./budgetRegulation.vue?vue&type=template&id=87cec16e&scoped=true"
import script from "./budgetRegulation.vue?vue&type=script&lang=js"
export * from "./budgetRegulation.vue?vue&type=script&lang=js"
import style0 from "./budgetRegulation.vue?vue&type=style&index=0&id=87cec16e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87cec16e",
  null
  
)

export default component.exports